<template>
  <div class="major-detail-container">
    <div class="card-top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--       v-loading="loading"
      element-loading-text="拼命加载中" -->
    <div
      class="detail-panel"
      ref="zyxqRef"
    >
      <div class="item-top">
        <h3 class="item-zymc">{{ majorDetail.zymc }}</h3>
        <el-button type="primary" size="mini" plain round @click="prev"
          >返回上级</el-button
        >
      </div>
      <div class="item-xz">
        专业代码：<span>{{
          majorDetail.zydm == "" ? "暂无信息" : majorDetail.zydm
        }}</span
        >&emsp; 授予学位：<span>{{
          majorDetail.xw == "" ? "暂无信息" : majorDetail.xw
        }}</span
        >&emsp; 学制：<span>{{
          majorDetail.xz == "" ? "暂无信息" : majorDetail.xz
        }}</span>
      </div>
      <el-tabs type="card">
        <el-tab-pane label="专业解读">
          <zyjd-item :majorDetail="majorDetail" />
        </el-tab-pane>
        <el-tab-pane label="开设院校">
          <div>
            <el-tabs v-model="currentName">
              <el-tab-pane label="本科批" name="0">
                <div class="mark" v-if="bkpcList.length > 0">
                  共找到<i class="count">{{ bkpcList.length }}</i
                  >所相关院校
                </div>
                <div class="mark" v-else>
                  暂无符合条件的院校，请查看其它批次
                </div>
                <div class="school-panel">
                  <div
                    class="school-item"
                    v-for="(item, index) in bkpcList"
                    :key="index"
                  >
                    <div class="school-logo">
                      <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                          path:'/main/schoolDetail/majorquery',
                          query: { item: item.gb,pc:item.pc }
                        }"
                      >
                        <img
                          :src="item.logo"
                          alt="院校logo"
                          width="100%"
                          height="100%"
                        />
                      </router-link>
                    </div>
                    <div class="school-info">
                      <div class="school-name">
                        <router-link
                          tag="a"
                          target="_blank"
                          :to="{
                            path:'/main/schoolDetail/majorquery',
                            query: { item: item.gb,pc:item.pc }
                          }"
                        >
                          <h3>{{ item.yxmc }}</h3>
                        </router-link>
                      </div>
                      <div class="school-description">
                        <span class="label" v-if="item.sfgb !== '0'"
                          >公办&nbsp;</span
                        >
                        <span class="label" v-else-if="item.sfmb !== '0'"
                          >民办&nbsp;</span
                        >
                        <span class="label" v-else-if="item.sfdl !== '0'"
                          >独立学院&nbsp;</span
                        >
                        <span class="label" v-if="item.sf985 !== '0'"
                          >985&nbsp;</span
                        >
                        <span class="label" v-if="item.sf211 !== '0'"
                          >211&nbsp;</span
                        >
                        <span class="label" v-else>普通高校</span>
                      </div>
                    </div>
                    <div class="prov">{{ item.yxdq }}</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="高职高专" name="1">
                <div class="mark" v-if="gzgzList.length > 0">
                  共找到<i class="count">{{ gzgzList.length }}</i
                  >所相关院校
                </div>
                <div class="mark" v-else>
                  暂无符合条件的院校，请查看其它批次
                </div>
                <div class="school-panel">
                  <div
                    class="school-item"
                    v-for="(item, index) in gzgzList"
                    :key="index"
                  >
                    <div class="school-logo">
                      <router-link
                        tag="a"
                        target="_blank"
                        :to="{
                          path: '/main/schoolDetail' + '/majorquery',
                          query: { item: item.gb,pc: item.pc }
                        }"
                      >
                        <img
                          :src="item.logo"
                          alt="院校logo"
                          width="100%"
                          height="100%"
                        />
                      </router-link>
                    </div>
                    <div class="school-info">
                      <div class="school-name">
                        <router-link
                          tag="a"
                          target="_blank"
                          :to="{
                            path: '/main/schoolDetail' + '/majorquery',
                            query: { item: item.gb,pc:item.pc }
                          }"
                        >
                          <h3>{{ item.yxmc }}</h3>
                        </router-link>
                      </div>
                      <div class="school-description">
                        <span class="label" v-if="item.sfgb !== '0'"
                          >公办&nbsp;</span
                        >
                        <span class="label" v-else-if="item.sfmb !== '0'"
                          >民办&nbsp;</span
                        >
                        <span class="label" v-else-if="item.sfdl !== '0'"
                          >独立学院&nbsp;</span
                        >
                        <span class="label" v-if="item.sf985 !== '0'"
                          >985&nbsp;</span
                        >
                        <span class="label" v-if="item.sf211 !== '0'"
                          >211&nbsp;</span
                        >
                        <span class="label" v-else>普通高校</span>
                      </div>
                    </div>
                    <div class="prov">{{ item.yxdq }}</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ZyjdItem from "./ZyjdItem";
import { mapState } from "vuex";
import { getMajorDetail, getMajorToSchool } from "../../../api/index";
export default {
  name: "MajorDetail",
  components: {
    ZyjdItem
  },
  data() {
    return {
      majorDetail: {},
      bkpcList: [],
      gzgzList: [],
      currentName: "0",
      module:{},
      loading: true
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    async getMajorDetail() {
      const loading = this.$loading({fullscreen:true,target:this.$refs.zyxqRef,text:"正在加载中"});
      let zydm = this.$route.query.zydm;
      let zymc = this.$route.query.zymc;
      const majorDetailResult = await this.module.getMajorDetail(zydm);
      console.log(majorDetailResult);
      if (majorDetailResult.data.code === 200) {
        const majorToDetailResult = await this.module.getMajorToSchool(
          this.userInfo.kl,
          zymc
        );
        console.log(majorToDetailResult);
        let schoolArray = majorToDetailResult.data.data;
        this.majorDetail = majorDetailResult.data.data;
        // this.loading = false;
        loading.close();
        let bkList = schoolArray.filter(
          item => {
            if(item){
              return item.sf1b === "1" || item.sf2b === "1" || item.sf3b === "1"
            }
          }
        );
        let gzgzList = schoolArray.filter((item, index) => {
          if(item){
            return item.sfzk === "1";
          }
        });
        this.bkpcList = bkList;
        this.gzgzList = gzgzList;
      }else if(majorDetailResult.data.code===500){
            if(majorDetailResult.data.message){
                this.$message({message:majorDetailResult.data.message,type:'error'});
            }else if(majorDetailResult.data.msg){
              this.$message({message:majorDetailResult.data.message,type:'error'});
            }
      }else if(majorDetailResult.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(majorDetailResult.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(majorDetailResult.status===409||majorDetailResult.status===410||majorDetailResult.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
    },
    async getApiIndexMethod(){
                const flag=this.$apiFlag;
                if(flag===1||flag===3){
                    this.module=await import("../../../api/index");
                }else if(flag===2){
                    this.module=await import("../../../api/index22");
                }
    },
    prev() {
      this.$router.go(-1);
    }
  },
  async mounted() {
    this.$store.commit('initIsUpdateToken');
    await this.getApiIndexMethod();
    await this.getMajorDetail();
  }
};
</script>
<style lang="stylus" scoped>
.major-detail-container
    min-width 1100px
    margin 0 auto
    min-height calc(100vh - 380px)
    min-height -moz-calc(100vh - 380px)
    min-height -webkit-calc(100vh - 380px) 
    .card-top
        width 1100px
        margin 20px auto
    .detail-panel
        width 1100px
        box-sizing border-box
        margin 0 auto
        padding  20px 50px
        background-color #ffffff
        .item-top
            display flex
            justify-content space-between
            height 30px
            margin-bottom 10px
            .item-zymc
                font-size 22px
                color #ff861a 
        .item-xz
           margin-bottom 25px 
           font-size 14px
           color #666  
        .mark
          color #666  
          .count
            color #ff6666
        .school-panel
            display flex
            flex-direction row
            flex-wrap wrap
            margin-top 20px
            max-height 500px
            overflow-y auto
          .school-item
            position relative
            width 450px
            height 80px
            display flex
            margin 0 10px 20px 0
            padding 16px 16px 5px 16px
            border 1px solid #ccc
            .school-logo
              width 70px
              height 70px
            .school-info
              margin-left 20px
              font-size 18px
              color #555
              .school-description
                margin-top 20px
                font-size 12px
                .label
                  padding 3px 5px
                  color #fff
                  border-radius 3px
                  background-color #75acff
            .prov
              position absolute 
              top 0
              right 0 
              padding 3px 12px
              font-size 14px
              color #fff
              background-color #84ccc9
          .school-item:nth-child(2n)  
            margin-right 0    

         
</style>
<style scoped>
h1,h2,h3,h4,h5,h6{
  font-weight: 700 !important;
}
.major-detail-container .detail-panel .school-item{
  box-sizing: content-box;
}
</style>